import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'ui-form-checkbox',
  imports: [ReactiveFormsModule, FormsModule],
  templateUrl: './form-checkbox.component.html',
  styleUrl: './form-checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormCheckboxComponent {
  dataCy = input<string>('');
  control = input<AbstractControl>();
  placeholder = input<string>('');
  description = input<string>('');
  class = input<string>('');
  modelInput = model<boolean>();
  changeCheckbox = output<boolean>();

  get formControl(): FormControl {
    return this.control() as FormControl;
  }
}
